import { APIResponse, PaginatedAPIResponse } from "../models/NetworkResponse";
import { deleteAPI, getAPI, postAPI, putAPI } from "./Networking";
import { Customer, CustomerRequestBody } from "../models/Customer/Customer";
import { GetCustomerParams } from "../models/Customer/getCustomerParams";
import { CustomerActivityLog } from "../models/Customer/CustomerActivityLog";

export default class CustomerAPI {
  getCustomers = async (
    filter: GetCustomerParams
  ): Promise<PaginatedAPIResponse<Customer>> => {
    try {
      const queryParams = new URLSearchParams();

      if (filter.page_no) {
        queryParams.append("page_no", filter.page_no.toString());
      }
      if (filter.limit) queryParams.append("limit", filter.limit.toString());

      if (filter.search_text) {
        queryParams.append("search_text", filter.search_text);
      }

      if (filter.is_partner) {
        queryParams.append("is_partner", filter.is_partner ? "true" : "false");
      }

      if (filter.sort_by) queryParams.append("sort_by", filter.sort_by);
      if (filter.sort_type)
        queryParams.append("sort_type", filter.sort_type.toString());
      queryParams.append("active", filter.active === false ? "false" : "true");

      const response = await getAPI(`/v5/customers?${queryParams.toString()}`);

      return response.result as PaginatedAPIResponse<Customer>;
    } catch (error) {
      throw error;
    }
  };

  updateCustomerDetails = async (
    customerDetails: CustomerRequestBody
  ): Promise<APIResponse> => {
    try {
      const response = await putAPI(`/v5/customers`, customerDetails);
      return response;
    } catch (error) {
      throw error;
    }
  };

  getCustomerDetailsById = async (customerId: number) => {
    try {
      const response = await getAPI(`/v5/customers/${customerId}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  createCustomer = async (
    customerDetails: CustomerRequestBody
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v5/customers`, customerDetails);
      return response;
    } catch (error) {
      throw error;
    }
  };

  deleteCustomer = async (customerId: number): Promise<APIResponse> => {
    try {
      const response = await deleteAPI(`/v5/customers/${customerId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
  getCustomerActivityLogs = async (
    customerId: number,
  ): Promise<CustomerActivityLog[]> => {
    try {
      const response = await getAPI(`/v5/customers/${customerId}/activity-logs`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

}
